/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { View, Text, StyleSheet, Font, Image } from "@react-pdf/renderer";
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";

const Lure = (content, valid = null, dir, index, option = null) => {
  const align = dir === "rtl" ? "right" : "left";
  const rowDir = dir === "rtl" ? "row-reverse" : "row";

  const styles = {
    lure: {
      display: "flex",
      flexDirection: rowDir,
      width: "100%",
      marginBottom: "0.125in",
      paddingLeft: "0.5in",
      paddingRight: "0.5in",
      alignItems: "center",
    },
    lurelabel: {
      flexShrink: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "0.5in",
      height: "0.5in",
    },
    lureicon: {
      width: "0.25in",
      height: "0.25in",
    },
    lurelabeltext: {
      textAlign: "center",
      fontSize: "12pt",
      fontWeight: "600",
    },
    lurecontent: {
      width: "7in",
      fontSize: dir === "rtl" ? "14pt" : "12pt",
      unicodeBidi: "isolate",
      lineHeight: 1.5,
    },
    luretext: {
      writingMode: "horizontal-tb",
      direction: dir,
      unicodeBidi: "isolate",
      textAlign: align,
      letterSpacing: "0px",
    },
  };

  // clear up all whitespace characters and replace with a single space
  content = content.replace(/\s+/g, " ");
  // remove leading and trailing whitespace
  content = content.replace(/^[\s\n]+|[\s\n]+$/g, "");
  // remove all html tags
  content = content.replace(/<[^>]*>/g, "");
  // remove non-breaking spaces
  content = content.replace(/&nbsp;/g, "");

  return (
    <div style={styles.lure} key={`${content}-${index}`}>
      <div style={styles.lurelabel}>
        {valid !== null ? (
          valid ? (
            <BASESvgIcon size={20}>heroicons-solid:check</BASESvgIcon>
          ) : (
            <BASESvgIcon size={20}>heroicons-solid:x</BASESvgIcon>
          )
        ) : (
          option !== null && <p style={styles.lurelabeltext}>{option}</p>
        )}
      </div>
      <div style={styles.lurecontent}>
        <p style={styles.luretext}>{content}</p>
      </div>
    </div>
  );
};

export default Lure;
